import React from 'react';
import { useLanguage } from '@/contexts';

interface CharacterCountProps {
  text: string;
  className?: string;
}

// Simple character count component
const CharacterCount: React.FC<CharacterCountProps> = ({ 
  text, 
  className = "mt-1 text-sm text-gray-500" 
}) => {
  const { t } = useLanguage();
  return (
  <p className={className}>
    {text.length} {t("characters")}
  </p>
)};

export default CharacterCount;
